import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import BasicButton, { BASIC_BUTTON_TYPE_OUTLINED } from '@divvy-web/skylab.basicbutton'
import { useController, useFormContext, useWatch } from '@divvy-web/skylab.react-hook-form'

import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

import styles from './styles.module.scss'

interface GoodFitWizardFormFooterProps {
  isScreeningForCreditApplication: boolean
}

const GoodFitWizardFormFooter = ({ isScreeningForCreditApplication }: GoodFitWizardFormFooterProps) => {
  const [getClassName] = useNameFormatter('GoodFitWizardFormFooter')
  const { control } = useFormContext()
  const { tracker } = useWebTracking()

  const {
    field: { value: currentStep, onChange: updateCurrentStep },
  } = useController({ control, name: '__currentStep' })
  const [annualRevenue, currentCash, creditRange] = useWatch({
    control,
    name: ['annualRevenue', 'currentCash', 'creditRange'],
  })
  const isEnabled = currentCash && annualRevenue && creditRange

  const showNextButton = (currentStep === 1 && annualRevenue !== '') || (currentStep === 2 && currentCash !== '')

  return (
    <div className={styles[getClassName('')]}>
      <div className={styles[getClassName('button-container')]}>
        {currentStep !== 1 && (
          <BasicButton
            disabled={isScreeningForCreditApplication}
            type={BASIC_BUTTON_TYPE_OUTLINED}
            onClick={() => {
              if (currentStep === 2) tracker?.track('se_signup__qualification_check_cash_balance_back__fired')
              if (currentStep === 3) tracker?.track('se_signup__qualification_check_credit_score_back__fired')
              updateCurrentStep(currentStep - 1)
            }}
          >
            <FormattedMessage
              defaultMessage='Back'
              id='sputnik.GoodFitWizardFormFooter__x2m5k'
            />
          </BasicButton>
        )}
        {showNextButton && (
          <BasicButton
            disabled={isScreeningForCreditApplication}
            onClick={() => {
              if (currentStep === 1) tracker?.track('se_signup__qualification_check_revenue_next__fired')
              if (currentStep === 2) tracker?.track('se_signup__qualification_check_cash_balance_next__fired')
              if (currentStep === 3) tracker?.track('se_signup__qualification_check_credit_score_submit__fired')
              updateCurrentStep(currentStep + 1)
            }}
          >
            <FormattedMessage
              defaultMessage='Next'
              id='sputnik.GoodFitWizardFormFooter__9+Ddtu'
            />
          </BasicButton>
        )}
        {currentStep === 3 && (
          <BasicButton
            buttonType='submit'
            disabled={isScreeningForCreditApplication || !isEnabled}
          >
            <FormattedMessage
              defaultMessage='Submit'
              id='sputnik.GoodFitWizardFormFooter__wSZR47'
            />
          </BasicButton>
        )}
      </div>
    </div>
  )
}

export default GoodFitWizardFormFooter
